import type { Pinia } from "pinia"
import { createRouter, createWebHistory } from "vue-router"
import AuthPage from "../pages/AuthPage.vue"
import ConnectionsPage from "../pages/ConnectionsPage.vue"
import DashboardPage from "../pages/DashboardPage.vue"
import DiagnosticsPage from "../pages/DiagnosticsPage.vue"
import DocumentationPage from "../pages/DocumentationPage.vue"
import EventsPage from "../pages/EventsPage.vue"
import NodesPage from "../pages/NodesPage.vue"
import RecommendationsPage from "../pages/RecommendationsPage.vue"
import RelayPage from "../pages/RelayPage.vue"
import SessionsPage from "../pages/SessionsPage.vue"
import { useAuthStore } from "../stores/auth"
import { dashboardEnvironment } from "../utils/env"

export function createDashboardRouter(pinia?: Pinia) {
  const router = createRouter({
    history: createWebHistory(dashboardEnvironment.routeBase),
    routes: [
      {
        path: "/auth",
        name: "auth",
        component: AuthPage,
        meta: { public: true }
      },
      {
        path: "/",
        name: "dashboard",
        component: DashboardPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/nodes",
        name: "nodes",
        component: NodesPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/connections",
        name: "connections",
        component: ConnectionsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/sessions",
        name: "sessions",
        component: SessionsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/relay",
        name: "relay",
        component: RelayPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/events",
        name: "events",
        component: EventsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/recommendations",
        name: "recommendations",
        component: RecommendationsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/diagnostics",
        name: "diagnostics",
        component: DiagnosticsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/documentation",
        name: "documentation",
        component: DocumentationPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/:pathMatch(.*)*",
        redirect: "/"
      }
    ],
    scrollBehavior() {
      return { top: 0 }
    }
  })

  router.beforeEach((to) => {
    const auth = useAuthStore(pinia)
    auth.restore()
    const fixtureBypass = dashboardEnvironment.fixtureAuthBypass

    if (to.meta.requiresAuth && !auth.isAuthenticated && !fixtureBypass) {
      return {
        path: "/auth",
        query: { redirect: to.fullPath }
      }
    }

    if (to.meta.public && auth.isAuthenticated) {
      return typeof to.query.redirect === "string" ? to.query.redirect : "/"
    }

    return true
  })

  return router
}
